<script setup>
defineProps({
  theme: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '',
  },
  buttonCaption: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
  },
  isButtonDisabled: {
    type: Boolean,
  },
});
</script>

<template>
  <!--  @TODO: think about themes ans sizes -->
  <button
    :class="{
      'button--yellow': theme === 'yellow',
      'button--purple': theme === 'purple',
      'button--green': theme === 'green',
      'button--transparent': theme === 'transparent',
      'button--large': size === 'large',
    }"
    :disabled="isButtonDisabled"
    :type="type"
    class="button"
  >
    <span>{{ buttonCaption }}</span>
  </button>
</template>

<style lang="postcss" scoped>
.button {
  font-size: 20px;
  font-weight: 700;
  line-height: 100%;
  width: 100%;
  max-width: fit-content;
  padding: 20px 40px;
  cursor: pointer;
  transition: var(--default-transition) background-color;
  letter-spacing: 0.4px;
  color: var(--black-color);
  border: none;
  border-radius: var(--border-radius);
  background-color: var(--green-color);

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &--large {
    max-width: 436px;
    margin: 36px 0 0;
  }

  &--green {
    background-color: rgb(var(--green-color--rgb), 1);
    transition: background 1s;
    color: #333;

    &:hover {
      background-color: rgb(var(--green-color--rgb), 0.9);
    }
  }

  &--purple {
    background-color: rgba(var(--accent-color--rgb), 0.9);
    color: var(--white-color);
    padding: 0 40px;
    line-height: 54px;

    &:hover {
      background-color: var(--accent-color);
    }
  }

  &--yellow {
    color: rgb(51, 51, 51);
    background-color: var(--subscribe-color);
  }

  &--yellow:hover {
    background-color: rgba(238, 223, 92, 100%);
  }

  &--transparent {
    background-color: transparent;
    color: rgba(var(--accent-color--rgb), 0.5);
  }

  &--transparent:hover {
    background-color: transparent;
  }

  @media (--small-vp) {
    font-size: 18px;
    max-width: 100%;

    &--yellow:hover {
      background-color: var(--subscribe-color);
    }

    &--transparent {
      font-size: 14px;
    }
  }
}
</style>
